// src/components/ui/cards/ListCard.js

import React from "react";
import CardWrapper from "../CardWrapper";

const ListCard = ({
  title,
  items = [],
  renderItem,
  emptyMessage = "No data available.",
  size = "medium",
  shape = "rectangle",
  scrollable = true,
}) => {
  return (
    <CardWrapper title={title} size={size} shape={shape}>
      <div
        className={`flex flex-col gap-2 ${
          scrollable ? "max-h-60 overflow-y-auto pr-2" : ""
        }`}
      >
        {items.length === 0 ? (
          <div className="flex-1 flex items-center justify-center min-h-[100px] text-gray-500 italic">
            {emptyMessage}
          </div>
        ) : (
          items.map((item, index) => (
            <div key={index} className="py-1 border-b last:border-b-0">
              {renderItem(item, index)}
            </div>
          ))
        )}
      </div>
    </CardWrapper>
  );
};

export default ListCard;